import { callZpayFunction } from '../../callZpayFunction';

// 토스트 메시지를 노출합니다
export const Toast = {
  show: (message: string) => {
    callZpayFunction('toast')({ message });
  },
};
